let script
export const loadSdk = () => new Promise(resolve => {
  if (script) return resolve(window.creditiq)

  script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.onload = script.onreadystatechange = function () {
    if (!script.readyState || /complete|loaded/.test(script.readyState)) {
      script.onload = script.onreadystatechange = null
      resolve(window.creditiq)
    }
  }
  script.src = 'https://checkout.staging.creditiq.com/ciq-sdk.js'

  const entry = document.getElementsByTagName('script')[0]
  entry.parentNode.insertBefore(script, entry)
})

export default {
  props: {
    token: {
      type: Object,
      required: true
    }
  },
  watch: {
    token: {
      async handler (newValue) {
        const sdk = await loadSdk()
        sdk.init({ sourceOrgId: '691e3a0f-bad5-4e4c-a5d8-aa742ef1ec96' })
        sdk.injectInline(this.$el, { authTokenBundle: this.token }, this.onChange)
      },
      immediate: true
    }
  },
  methods: {
    onChange (event, application) {
      console.log('CHECKOUT: ' + event, application.status, application)
    }
  },
  render: h => h('section')
}
